import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';

import { TyreReading } from '@/generated/GeneratedApiTypes';
import { Variant, VARIANT_BG_CLASS, VARIANT_TEXT_CLASS } from './TyreLabel';
import { getPressureStatusKey, getPressureVariant, getTemperatureStatusKey, getTemperatureVariant } from './utils';

const StatusRow = ({ label, value, variant }: { label: ReactNode; value: ReactNode; variant: Variant }) => (
    <div
        className={
            `display-flex justify-content-between align-items-center ` +
            `padding-5 gap-5 rounded-small ${VARIANT_BG_CLASS[variant]}`
        }
    >
        <span className="text-color-darkest">{label}</span>
        <span className={`text-bold ${VARIANT_TEXT_CLASS[variant]}`}>{value}</span>
    </div>
);

export const TyreDetailSkeleton = () => (
    <div className="display-flex flex-column gap-5" aria-busy="true" aria-live="polite">
        <div
            className="display-flex justify-content-between align-items-center
        padding-5 gap-5 rounded-small bg-highlight-decent"
        >
            <ContentLoader height={16} width={120} />
            <ContentLoader height={16} width={80} />
        </div>
        <div
            className="display-flex justify-content-between align-items-center
         padding-5 gap-5 rounded-small bg-highlight-decent"
        >
            <ContentLoader height={16} width={120} />
            <ContentLoader height={16} width={80} />
        </div>
    </div>
);

const TyreDetail = ({ tyre }: { tyre?: TyreReading }) => {
    const pressureVariant = getPressureVariant(tyre?.pressure_status);
    const tempVariant = getTemperatureVariant(tyre?.temperature_status);
    const pressureKey = getPressureStatusKey(tyre?.pressure_status);
    const temperatureKey = getTemperatureStatusKey(tyre?.temperature_status);

    return (
        <div className="display-flex flex-column gap-5">
            <StatusRow
                label={<FormattedMessage id="intl-msg:tyres.pressure" />}
                value={pressureKey ? <FormattedMessage id={pressureKey} /> : '-'}
                variant={pressureVariant}
            />
            <StatusRow
                label={<FormattedMessage id="intl-msg:tyres.temperature" />}
                value={temperatureKey ? <FormattedMessage id={temperatureKey} /> : '-'}
                variant={tempVariant}
            />
        </div>
    );
};

export default TyreDetail;
